import { Paper, styled } from '@mui/material';

interface ItemProps {
  active?: boolean;
}

export const Item = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'active',
})<ItemProps>(({ theme, active }) => ({
    'backgroundColor': theme.palette.common.white,
    'padding': active ? '0.4375rem 0.5rem' : '0.5rem 0.5625rem',
    'textAlign': 'center',
    'fontSize': '0.75rem',
    'fontWeight': theme.typography.fontWeightSemiBold,
    'color': theme.palette.dark,
    'textTransform': 'uppercase',
    'cursor': 'pointer',
    'minHeight': '2.25rem',
    'minWidth': '2.125rem',
    'wordBreak': 'break-word',
    'marginBottom': '8px',
    'boxShadow': 'none',
    'border': active ?
        `2px solid ${theme.palette.primaryColor}` :
        `1px solid ${theme.palette.clouds}`,

    '& label': {
        cursor: 'pointer',
        position: 'relative',
        display: 'block',
    },
    '& label > .MuiRadio-root, & label > .MuiCheckbox-root': {
        position: 'absolute',
        left: 0,
        top: -10,
        opacity: 0,
    },
}));

// export const Item = styled(Paper)(({ theme }) => ({
//     ...{
//         backgroundColor: theme.palette.common.white,
//         padding: '0.5rem 0.5625rem',
//         textAlign: 'center',
//         fontSize: '0.75rem',
//         fontWeight: theme.typography.fontWeightSemiBold,
//         color: theme.palette.dark,
//         textTransform: 'uppercase',
//         cursor: 'pointer',
//         minHeight: '2.25rem',
//         minWidth: '2.125rem',
//         // whiteSpace: 'nowrap',
//         wordBreak: 'break-word',
//         marginBottom: '8px',
//         boxShadow: 'none',
//         border: `1px solid ${theme.palette.clouds}`,
//     },
//     '&.active': {
//         padding: '0.4375rem 0.5rem',
//         border: `2px solid ${theme.palette.primaryColor}`,
//     },
//     '& label': {
//         cursor: 'pointer',
//         position: 'relative',
//         display: 'block',
//     },
//     '& label > .MuiRadio-root, & label > .MuiCheckbox-root': {
//         position: 'absolute',
//         left: 0,
//         top: -10,
//         opacity: 0,
//     },
// }));
